import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LoaderService } from '../../../../shared/services/loader.service';
import { SearchService } from '../../services/search.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { SearchRequest } from '../../models/search-request.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-error-data',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule],
  templateUrl: './error-data.component.html',
  styleUrl: './error-data.component.scss',
  standalone: true,
  providers: [],
})
export class ErrorDataComponent {

  searchForm!: FormGroup;
  nameFieldSearch = '';
  uuidClient:number = 536;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loader: LoaderService,
    private searchService: SearchService,
    private notificationService: NotificationService,
    private route:ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {

  }
  ngOnInit(): void {
    // Scroll hacia arriba al cargar la página
    window.scrollTo(0, 0);
    
    this.clearDataState();
    this.searchForm = this.fb.group({
      numero_empleado: ['', Validators.required]
    });
    
    this.route.queryParams.subscribe((params) =>{
      this.uuidClient = parseInt(params['uiidc'] == undefined ? 536: params['uiidc']);
      this.getLoadConfigurationByAccount(this.uuidClient);
    });
  }

  onSearchSubmit():void {
    if (this.searchForm.invalid) return;
    this.loader.show();
    const searchPayload: SearchRequest = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        key: this.searchForm.value.numero_empleado,
        sponsor: "536",
      }
    }

    this.searchService.searchAfilliate(searchPayload).subscribe({
      next: (response) => {
        this.loader.hide();
        if(response.response.results.length > 0){
          this.goToRegister(response);
        }else{
          this.notificationService.showError('El usuario ingresado no se encuentra registrado en el sistema. Verifique los datos e intente nuevamente.', 'Usuario No Encontrado');
        }
      },
      error: (err) => {
        this.loader.hide();
        this.notificationService.showError('No se pudo conectar con el servidor. Verifique su conexión a internet e intente nuevamente.', 'Error de Conexión');
      }
    });
  }

  setValueFieldSearch(value:string):void{
    setTimeout(() => {
      this.nameFieldSearch = value;
      this.cd.detectChanges();
    }, 200);
  }

  getLoadConfigurationByAccount(uuidClient:number):void{
    this.searchService.loadConfig(uuidClient).subscribe({
      next: (response) => {
        if (response?.success) {
          this.setValueFieldSearch(response.account.key.description);
        }
        this.cd.detectChanges();
      },
      error: (err) => {
        this.setValueFieldSearch('Número de empleado');
        this.cd.detectChanges();
      }
    });
  }
  
  clearDataState():void {
    history.replaceState({}, '', window.location.href);
  }

  goToRegister(results:any):void {
    this.router.navigateByUrl('/registro', {
      state: {
        data: results
      }
    });
  }


}
